import React from "react";
import { ICustomSquareButtonProps } from "./interface/interface";
import { Button, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../../helpers";
import { CustomButton } from "./CustomButton";
import { useTheme } from "@mui/material/styles";

export const CustomSquareButton: React.FC<ICustomSquareButtonProps> = (
  props
) => {
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";
  const { title, sx, icon } = props;

  const lightModeStyles = isLightMode
    ? {
      // needed Changes 
      color: theme.palette.primary.contrastText,
    }
    : {};
    
    // bgcolor: theme.palette.primary.dark,
    // color: theme.palette.primary.contrastText,
  if (title) {
    return (
      <CustomButton
        {...props}
        // variant="contained"
        sx={{
          borderRadius: 2,
          py: 1,
          px: 2,
          border: isLightMode ? "1px solid var(--border-light-color)" : "1px solid var(--border-dark-color)",
          backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
          color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
          "&:hover": {
            backgroundColor: isLightMode
              ? "var(--secondary-color)"
              : "var(--tertiary-color)",
            opacity: isLightMode ? 0.85 : 1,
          },
          // ...lightModeStyles,
          ...sx,
        }}
      >
        <Typography variant="h5" fontWeight={900}>
          {title}
        </Typography>
      </CustomButton>
    );
  }

  if (icon) {
    return (
      <Button
        {...props}
        variant="contained"
        sx={{
          backgroundColor: isLightMode
            ? "var(--secondary-color)"
            : "var(--primary-color)",
          color: isLightMode
            ? "var(--text-light-color)"
            : "var(--text-dark-color)",
          border: isLightMode
            ? "1px solid var(--border-light-color)"
            : "1px solid var(--border-dark-color)",
          "&:hover": {
            backgroundColor: isLightMode
              ? "var(--secondary-color)"
              : "var(--tertiary-color)",
            opacity: isLightMode ? 0.85 : 1,
          },

          borderRadius: 2,
          py: 1,
          px: 1,
          minWidth: "48px",
          ...lightModeStyles,
          ...sx,
        }}
      >
        {icon}
      </Button>
    );
  }

  return <></>;
};
